var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Config from './Config';
var SendRoutine = /** @class */ (function () {
    function SendRoutine(start, onDidSync) {
        if (start === void 0) { start = false; }
        this.onDidSync = onDidSync;
        this.interval = undefined;
        if (start)
            this.start();
    }
    SendRoutine.prototype.start = function () {
        var _this = this;
        if (this.interval == undefined)
            this.processQueue();
        this.interval = this.interval || setInterval(function () {
            _this.processQueue();
        }, Config.SEND_INTERVAL);
    };
    SendRoutine.prototype.stop = function () {
        clearInterval(this.interval);
        this.interval = undefined;
    };
    /**
     * Flush the queue immediately instead of waiting for the next interval tick.
     * Used right after a CTA click so a navigation away from the page (especially
     * to an external domain) doesn't strand the click in the queue. The send uses
     * `keepalive`, so an in-flight request survives the unload.
     */
    SendRoutine.prototype.flush = function () {
        this.processQueue();
    };
    /**
     * Send `events` right away, bypassing the consent-gated localStorage queue.
     * Used for events that must be delivered regardless of the analytics
     * purpose — a Form Builder submission, whose form carries its own mandatory
     * data-processing acceptance. `keepalive` on the underlying fetch keeps the
     * request alive across the form's post-submit navigation. Failures are
     * logged and dropped: re-queueing would park the event behind a consent
     * gate that may never open.
     *
     * `credentialed: false` (no analytics consent) sends without cookies: the
     * `cdpf_did` cookie neither travels nor gets set by the response.
     */
    SendRoutine.prototype.sendNow = function (events, credentialed) {
        if (credentialed === void 0) { credentialed = true; }
        return __awaiter(this, void 0, Promise, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (events.length === 0)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.sendEvents(events, credentialed)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error sending events:", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SendRoutine.prototype.processQueue = function () {
        return __awaiter(this, void 0, Promise, function () {
            var queue;
            return __generator(this, function (_a) {
                queue = JSON.parse(localStorage.getItem(Config.LS_EVENTS_QUEUE) || "[]");
                if (queue.length === 0)
                    return [2 /*return*/];
                localStorage.removeItem(Config.LS_EVENTS_QUEUE);
                this.sendEvents(queue)
                    .catch(function (error) {
                    console.error("Error sending events:", error);
                    var newQueue = JSON.parse(localStorage.getItem(Config.LS_EVENTS_QUEUE) || "[]");
                    localStorage.setItem(Config.LS_EVENTS_QUEUE, JSON.stringify(queue.concat(newQueue)));
                });
                return [2 /*return*/];
            });
        });
    };
    SendRoutine.prototype.sendEvents = function (events, credentialed) {
        if (credentialed === void 0) { credentialed = true; }
        return __awaiter(this, void 0, Promise, function () {
            var controller, timeoutId;
            var _this = this;
            return __generator(this, function (_a) {
                controller = new AbortController();
                timeoutId = setTimeout(function () { return controller.abort(); }, Config.SEND_TIMEOUT);
                return [2 /*return*/, fetch(Config.SERVER_URL + "/events", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ events: events }),
                        keepalive: true,
                        mode: 'cors',
                        // Needed to send/receive the did cookie core-input sets on its own
                        // (cross-site) domain — see core-input's didCookie.ts.
                        credentials: credentialed ? 'include' : 'omit',
                        signal: controller.signal
                    }).then(function (res) {
                        clearTimeout(timeoutId);
                        if (credentialed)
                            void _this.syncDidFromResponse(res);
                        return res;
                    })];
            });
        });
    };
    SendRoutine.prototype.sendTopics = function (event) {
        return __awaiter(this, void 0, Promise, function () {
            var controller, timeoutId, options;
            var _this = this;
            return __generator(this, function (_a) {
                controller = new AbortController();
                timeoutId = setTimeout(function () { return controller.abort(); }, Config.SEND_TIMEOUT);
                options = {
                    browsingTopics: true,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ events: [event] }),
                    keepalive: true,
                    mode: 'cors',
                    credentials: 'include',
                    signal: controller.signal
                };
                return [2 /*return*/, fetch(Config.SERVER_URL + "/events", options).then(function (res) {
                        clearTimeout(timeoutId);
                        void _this.syncDidFromResponse(res);
                        return res;
                    })];
            });
        });
    };
    /**
     * Adopt the `did` core-input resolved for this batch (its cookie, when it
     * disagreed with what we sent — see Device.syncDeviceID). Best-effort: an
     * empty/non-JSON body (e.g. the mocked `Response` in tests, or a network
     * error response) is silently ignored rather than breaking the send.
     */
    SendRoutine.prototype.syncDidFromResponse = function (res) {
        return __awaiter(this, void 0, Promise, function () {
            var body, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.onDidSync || !res.ok)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, res.json()];
                    case 2:
                        body = _b.sent();
                        if (body === null || body === void 0 ? void 0 : body.did)
                            this.onDidSync(body.did);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return SendRoutine;
}());
export default SendRoutine;
